// GENERATED FILE - do not edit.
// Emitted by tools/generate-wire-schemas.mjs from
// Server/src/Shared/Server/Resources/openapi.json (the spec lockfile).
// Regenerate with: npm run generate:wire
//
// Base wire shape for the server "ChatRoutingLogDto" component. The corresponding
// *.schema.ts is the facade that names it (and hosts any future refinement);
// see design/wiki/wire-schemas.md.
import { z } from "zod";
import { ChatRoutingLogSource } from "./chat-routing-log-source.enum.gen";
import { ChatRoutingCandidateGenShape } from "./chat-routing-candidate.gen";
import { ChatRoutingMatchGenShape } from "./chat-routing-match.gen";
import { ChatRoutingIssueGroupGenShape } from "./chat-routing-issue-group.gen";
import { ChatRoutingOutcome } from "./chat-routing-outcome.enum.gen";
import { ChatRoutingLogVersionsGenShape } from "./chat-routing-log-versions.gen";
import { ChatRoutingTimingsGenShape } from "./chat-routing-timings.gen";
import { ChatRoutingUsageGenShape } from "./chat-routing-usage.gen";
import { ChatFeedbackDtoGenShape } from "./chat-feedback-dto.gen";

export const ChatRoutingLogDtoGenShape = z.strictObject({
  id: z.string(),
  time: z.string(),
  configId: z.string().optional(),
  libraryId: z.string().optional(),
  source: z.enum(ChatRoutingLogSource),
  regressionRunId: z.string().optional(),
  regressionCaseId: z.string().optional(),
  conversationId: z.string().optional(),
  redactedInput: z.string(),
  redactedCategories: z.array(z.string()),
  crisisFlags: z.array(z.string()),
  tenure: z.string().optional(),
  issues: z.array(z.string()),
  shortlist: z.array(ChatRoutingCandidateGenShape),
  matches: z.array(ChatRoutingMatchGenShape),
  issueGroups: z.array(ChatRoutingIssueGroupGenShape),
  coverageGaps: z.array(z.string()),
  outcome: z.enum(ChatRoutingOutcome),
  errorClass: z.string().optional(),
  clarifyingQuestion: z.string().optional(),
  clarifierChoices: z.array(z.string()),
  versions: ChatRoutingLogVersionsGenShape,
  timings: ChatRoutingTimingsGenShape.optional(),
  usage: ChatRoutingUsageGenShape.optional(),
  feedback: z.array(ChatFeedbackDtoGenShape),
});
